<template>
    <div class="mb-0 ml-0 mr-0 pl-0 pr-0 mt-0 tw-flex tw-flex-wrap sm:tw-flex-no-wrap tw-flex-col sm:tw-flex-row xl:tw-flex-row sm:tw-items-start tw-m-2 tw-p-2">
        <div class="tw-flex-grow sm:tw-flex-grow-0 md:tw-flex-grow-0 lg:tw-flex-grow-0 xl:tw-flex-grow-0 tw-p-0 tw-m-0 tw-max-h-cover tw-shadow" :style="'background: url(' + ptracks[0].cover + ');background-repeat: no-repeat;background-position:center;background-size: cover'">
            <div class="tw-relative tw-shadow tw-max-w-full play-controls">
                <div class="tw-flex tw-flex-col tw-items-center tw-p-0 tw-m-0">
                    <div class="tw-flex-grow tw-h-full tw-max-h-coverx tw-w-full tw-m-3 tw-items-center tw-align-middle tw-mt-1 tw-mx-auto tw-mb-3 tw-p-2 transform-80">
                        <v-circle :percent="progressPercent" stroke-width="3" stroke-linecap="square" :strokeColor="color"/>
                    </div>
                    <div class="tw-inline-flex tw-px-0 tw-py-1 tw-mb-2 tw-align-middle tw-justify-around pctrl tw-rounded-full">
                        <div class="tw-mx-4">
                            <span @click="prevSong()"><SkipBackwardIcon v-bind:class="[(pcollectionId == collectionId) && (audio.readyState >= 1) ? 'tw-text-white tw-cursor-pointer' : 'tw-text-white tw-cursor-pointer disabled', '']" w="30" h="30" /></span>
                        </div>
                        <div class="mx-4">
                            <span @click="play()"><PlayIcon class="tw-text-white tw-cursor-pointer" v-show="((pcollectionId == collectionId) && !isPlaying && !playerIsBuffering) || (pcollectionId != collectionId)" w="30" h="30"/></span>
                            <span @click="play()"><PauseIcon class="tw-text-white tw-cursor-pointer" v-show="(pcollectionId == collectionId) && isPlaying && !playerIsBuffering" w="30" h="30" /></span>
                            <span><BufferingIcon class="tw-text-white tw-cursor-pointer" animate="rotate" v-show="(pcollectionId == collectionId) && playerIsBuffering" w="30" h="30" /></span>
                        </div>
                        <div class="tw-mx-4">
                            <span @click="stop()"><SquareIcon class="tw-text-white tw-cursor-pointer" w="30" h="30" /></span>
                        </div>
                        <div class="tw-mx-4">
                            <span @click="nextSong()"><SkipForwardIcon v-bind:class="[(pcollectionId == collectionId) && (audio.readyState >= 1) ? 'tw-text-white tw-cursor-pointer' : 'tw-text-white tw-cursor-pointer disabled', '']" w="30" h="30" /></span>
                        </div>
                    </div>
                    <div class="tw-flex-grow track-scrubbing tw-mx-5 pctrl">
                        <vue-slider v-bind:class="[(pcollectionId == collectionId) && (audio.readyState >= 1) ? '' : 'disabled', '']" :width="260" @change="scrubChange()" v-model="playerProgressPercent" :process="true" :interval="0.01"></vue-slider>
                    </div>
                    <div class="tw-inline-flex tw-items-start tw-px-2 tw-mx-0 tw-w-full tw-align-middle tw-justify-around pctrl">
                        <div class="tw-inline-flex tw-items-center tw-align-middle tw-m-1">
                            <vue-slider :width="120" :duration="0.1" :min="0" :max="1" v-model="playerVolume" :process="true" :interval="0.01"></vue-slider>
                            <!-- <span v-tooltip.top-center="continuousPlay ? 'Repeat: ALL' : 'Repeat: OFF'" @click="changeContinuousPlay()" :class="continuousPlay ? 'tw-p-1 tw-bg-transparent tw-text-primary-green' : 'tw-p-1 tw-bg-transparent tw-text-white'"><RefreshIcon/></span> -->
                        </div>
                        <div class="tw-p-2">
                            <div class="tw-text-sm tw-text-white"> {{timeBufferMins}} : {{timeBufferSecs | doubleDigits}} - {{currentTrackDuration}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="tw-flex-grow tw-pt-0 tw-pl-0 sm:tw-pl-2 tw-mt-2 sm:tw-mt-0 tw-ml-0 sm:tw-ml-2" style="max-height: 430px; overflow-y: auto;">
            <div>
                <span><u>{{ pcollectionType }}</u>: <b>{{ pcollectionName }}</b></span>
                <span class="float-right"><u>{{ pcollectionByText }}</u>: <b>{{ pcollectionByName }}</b></span>
            </div>
            <hr />
            <songs-playlist :current-track-id="presentSongId" @playSelectSong="playSong" :tracks="ptracks"></songs-playlist>
        </div>
    </div>
</template>

<script>
    import {mapState, mapGetters } from 'vuex'
    import SongsPlaylist from './SongsPlaylist'
    import VueSlider from 'vue-slider-component'
    import { VCircle } from 'v-progress'
    import Vue from 'vue'
    import VTooltip from 'v-tooltip'
    import './../../../../../css/tooltip.css'
    import RefreshIcon from 'vue-ionicons/dist/md-refresh'
    import SkipBackwardIcon from 'vue-ionicons/dist/md-skip-backward'
    import PlayIcon from 'vue-ionicons/dist/md-play'
    import PauseIcon from 'vue-ionicons/dist/md-pause'
    import SquareIcon from 'vue-ionicons/dist/md-square'
    import SkipForwardIcon from 'vue-ionicons/dist/md-skip-forward'
    import BufferingIcon from 'vue-ionicons/dist/md-refresh'
    import PlayerUtils from './../../../../mixins/player-utils'
    Vue.use(VTooltip);
    export default {
        name: 'MainPlayer',
        props: ['ptracks'],
        components: {
            SongsPlaylist, VCircle, RefreshIcon,SkipBackwardIcon, PlayIcon, PauseIcon, SquareIcon, SkipForwardIcon, VueSlider, BufferingIcon
        },
        mixins: [PlayerUtils],
        data(){
            return { playerVolume: 0, playerProgressPercent: 0, hidePlayer: false}
        },
        mounted(){
            if (this.pcollectionId == this.collectionId && this.audio.readyState >= 1) {
                this.$store.dispatch('player/updateTimeLapse', false)
                this.$store.dispatch('player/viewShit')
            }
        },
        computed:{
            tracks(){
                return this.$store.state.player.tracks;
            },
            pcollectionName(){
                return this.$store.state.player.pcollectionName;
            },
            pcollectionType(){
                return this.$store.state.player.pcollectionType;
            },
            pcollectionId(){
                return this.$store.state.player.pcollectionId;
            },
            collectionId(){
                return this.$store.state.player.collectionId;
            },
            pcollectionByText(){
                return this.$store.state.player.pcollectionByText;
            },
            pcollectionByName(){
                return this.$store.state.player.pcollectionByName;
            },
            presentSongId(){
                if (this.pcollectionId && this.pcollectionId == this.collectionId) {
                    return this.$store.state.player.presentSongId;
                } else {
                    return -1;
                }
            },
            lastSongId(){
                return this.$store.state.player.lastSongId;
            },
            isPlaying(){
                return this.$store.state.player.isPlaying;
            },
            audio(){
                return this.$store.state.player.audio;
            },
            isPaused(){
                return this.$store.state.player.isPaused;
            },
            timeBufferSecs(){
                if (this.pcollectionId && this.pcollectionId == this.collectionId) {
                    return this.$store.state.player.timeBufferSecs;
                } else {
                    return 0;
                }
            },
            timeBufferMins(){
                if (this.pcollectionId && this.pcollectionId == this.collectionId) {
                    return this.$store.state.player.timeBufferMins;
                } else {
                    return 0;
                }
            },
            currentTrackTime(){
                return this.$store.state.player.currentTrackTime;
            },
            lastRecordedTrackTime(){
                return this.$store.state.player.lastRecordedTrackTime;
            },
            countCheck(){
                return this.$store.state.player.countCheck;
            },
            currentTrackDuration(){
                if (this.pcollectionId && this.pcollectionId == this.collectionId) {
                    return this.$store.state.player.currentTrackDuration;
                } else {
                    return 0;
                }
            },
            color(){
                return this.$store.state.player.color;
            },
            progressPercent(){
                if (this.pcollectionId && this.pcollectionId == this.collectionId) {
                    return this.$store.state.player.progressPercent;
                } else {
                    return 0;
                }
            },
            continuousPlay(){
                return this.$store.state.player.continuousPlay;
            },
            timeLapse(){
                return this.$store.state.player.timeLapse;
            },
            volume(){
                return this.$store.state.player.volume;
            },
            playerIsBuffering(){
                return this.$store.state.player.playerIsBuffering;
            },
            ...mapGetters({getVolume: 'player/getVolume'})
        },
    }
</script>

<style scopped>
    .vue-progress-circle{
        width: fit-content !important;
        width: -moz-fit-content !important;
    }
    .track-scrubbing > div{
        padding: 0 !important;
    }
    .pctrl{
        background: rgba(51, 51, 51, 0.85);
        border: solid 1px rgba(51, 51, 51, .4) ;
    }
    .play-controls{
        background: linear-gradient(to bottom right, rgba(255, 255, 255, 0.2), rgba(0, 0, 0, 0.4), rgba(255, 255, 255, 0.2));
    }
    h3{
        font-size: 24px;
        font-family: "Berlin Sans FB";
        font-weight: 800;
    }
    .disabled{
        pointer-events: none;
        opacity: 0.5;
    }
</style>
